"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.yieldToMain = void 0;
// https://github.com/wix-private/thunderbolt/blob/1985e745e83001c96767b20c413c7c63ad545c37/packages/thunderbolt-commons/src/performance/taskify.ts#L2
// break long task to smaller tasks, see here: https://web.dev/optimize-long-tasks/#use-asyncawait-to-create-yield-points
var yieldToMain = function () {
    return new Promise(function (resolve) { return setTimeout(resolve, 0); });
};
exports.yieldToMain = yieldToMain;
//# sourceMappingURL=yieldToMain.js.map